import React, { useState } from 'react';

import GooglePlacesAutocomplete, { geocodeByPlaceId, getLatLng } from 'react-google-places-autocomplete';
import Select from 'react-select';

const LocationField = () => {
    const [mapsLoaded, setMapsLoaded] = useState(false);

    window.setMapsLoaded = () => {
        setMapsLoaded(true);
    };

    if (mapsLoaded === false) {
        return null;
    }

    const onChangeLocation = async (option) => {
        const geocode = await geocodeByPlaceId(option.value.place_id);
        const coordinates = await getLatLng(geocode[0]);

        console.log(coordinates);
        window.setSearchLocation(coordinates);
    }

    const onChangeRadius = async (option) => {
        window.setSearchRadius(option.value);
    }

    return (
        <div className="location-field-wrapper">
            <GooglePlacesAutocomplete
                selectProps={{
                    className: 'react-select location-field',
                    classNamePrefix: 'react-select',
                    onChange: onChangeLocation,
                    placeholder: 'Locatie',
                    noOptionsMessage: () => null,
                    components: {
                        DropdownIndicator: () => (
                            <svg className="react-select__location-icon" viewBox="0 0 48 48">
                                <use xlinkHref="#icon-location" />
                            </svg>
                        ),
                        ClearIndicator: () => null,
                        IndicatorSeparator: () => null,
                        LoadingIndicator: () => null,
                    },
                }}
            />
            <Select
                className="react-select radius-field"
                classNamePrefix="react-select"
                options={[
                    { value: 15000, label: '15 km' },
                    { value: 20000, label: '20 km' },
                    { value: 25000, label: '25 km' },
                    { value: 30000, label: '30 km' },
                    { value: 40000, label: '40 km' },
                    { value: 50000, label: '50 km' },
                    { value: 100000, label: '100 km' },
                ]}
                onChange={onChangeRadius}
                placeholder="15 km"
                noOptionsMessage={null}
                components={{
                    DropdownIndicator: () => (
                        <svg className="react-select__dropdown-icon" viewBox="0 0 48 48">
                            <use xlinkHref="#icon-dropdown" />
                        </svg>
                    ),
                    ClearIndicator: () => null,
                    IndicatorSeparator: () => null,
                    LoadingIndicator: () => null,
                }}
            />
        </div>
    );
}

export { LocationField };
